export enum DocMimeType {
  JPG = 'jpg',
  PDF = 'pdf'
}
